// extracted by mini-css-extract-plugin
export default {"AccordionCommentItem":"AccordionCommentItem_AccordionCommentItem__zpXko","Header":"AccordionCommentItem_Header__9Xp1j"};